import { useEffect, useState } from "react";

import { getFiltersFromStorage } from "@/components/AgendaFilters/utils/getFiltersFromStorage";

export const useInitializeStoredTimeOfDayFilters = (
  startTime: string | null,
  endTime: string | null,
  facilityId: string | null,
  setTimes: (times: { timeGTE?: string; timeLTE?: string }) => void
) => {
  const [filterLoaded, setFilterLoaded] = useState(false);
  useEffect(() => {
    if (!facilityId || filterLoaded) {
      return;
    }

    const loadFilters = async () => {
      try {
        const [storedStartTime, storedEndTime] = await Promise.all([
          getFiltersFromStorage(
            `x-whoosh-${facilityId}-time-of-day-start-time`
          ),
          getFiltersFromStorage(`x-whoosh-${facilityId}-time-of-day-end-time`),
        ]);

        const timeGTE = storedStartTime || startTime || undefined;
        const timeLTE = storedEndTime || endTime || undefined;

        if (timeGTE || timeLTE) {
          setTimes({
            timeGTE,
            timeLTE,
          });
        }
      } catch (error) {
        setFilterLoaded(true);
      }
    };

    loadFilters().finally(() => {
      setFilterLoaded(true);
    });
  }, [startTime, endTime, setTimes, facilityId, filterLoaded]);

  return filterLoaded;
};
